module.exports = __webpack_public_path__ + "static/assets/7890313989904c903d546b8ee749b215.svg";